module.exports = __webpack_public_path__ + "img/gastro.a0f96cbf.png";